import * as React from 'react';
import { useSelector } from 'react-redux';

import { openUserCard } from '../../../../actions/userCard/openUserCard';
import { ChatCompanionTitle } from '../../../../components/ChatCompanionTitle';
import { selectChatUserTitle } from '../../../../selectors/chatUserTitleSelector';
import { useAppDispatch } from '../../../../types/redux/state';

interface ICustomCompanionTitleContainerProps {
  companionId?: number;
}

export const CustomCompanionTitleContainer = ({ companionId }: ICustomCompanionTitleContainerProps) => {
  const dispatch = useAppDispatch();

  const headerTitle = useSelector(selectChatUserTitle);

  const handleClickName = React.useCallback(() => {
    if (companionId) {
      dispatch(openUserCard(companionId));
    }
  }, [companionId, dispatch]);

  return <ChatCompanionTitle {...headerTitle} dataTestId="chat_header_title" handleClickName={handleClickName} />;
};
